export default "__VITE_ASSET__DmX3ol9U__"